import BoardHeader from "../Headers/BoardHeader/BoardHeader.jsx";
import Footer from "../Footer/Footer";
import AlertModal from "../AlertModal/AlertModal.jsx";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import Loading from "../loadingModal/LoadingModal";
import "./index.css";
import BoardHeaderMobile from "../Headers/BoardHeaderMobile/BoardHeaderMobile.jsx";
import Navbar from "../Navbar/Navbar.jsx";
import useLogin from "../../hooks/useLogin.js";

const Layout = ({ isProtected, component: Component }) => {
  const { loggedUser } = useLogin();
  const mediaQuery = window.matchMedia("(max-width: 427px)");

  return (
    <div className="general-content">
      <Loading />
      <ConfirmModal />
      <AlertModal />
      <div className="H-and-middle">
        <div className="B-H">
          {!mediaQuery.matches ? <BoardHeader /> : <BoardHeaderMobile />}
        </div>
        <div className="structure-center">
          {!mediaQuery.matches ? (
            <div className="navbar-c">
              <Navbar />
            </div>
          ) : null}
          <div className="dash-content">
            {isProtected && loggedUser.isLogged && <Component />}
          </div>
        </div>
      </div>
      {!mediaQuery.matches ? (
        <div className="con-foo">
          <Footer classN="fooInDash" />
        </div>
      ) : null}
    </div>
  );
};

export default Layout;
